import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import PageTitle from '../../components/PageTitle'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import DrawerWork from './DrawerWork'
import PopupWorkForm from './PopupWorkForm'
import PopupUpdateWork from './PopupUpdateWork/PopupUpdateWork'
import PopupAddPersonWork from './PopupAddPersonWork'
// Style Component
// Ant design
import { Button, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
// Other
import { inject, observer } from 'mobx-react'
import ListWork from './ListWork/ListWork'
import queryString from 'query-string'
import selectPeopleStore from '../../stores/selectPeopleStore'
import { useLocation } from 'react-router-dom'
import PopupElectronicReleaseForm from './PopupElectronicReleaseForm'
import utils from '../../utils'
import AccessControlAction from '../../components/AccessControlAction'
import { ACL_ACTION_TYPE, ASSIGNEE_TYPE } from '../../constants'
import { WorkPageWrapper } from './WorkStyledPage'
import useOpenItem from '../../hooks/useOpenItem'
import { PopupAddPersonVote, PopupEditPersonVote } from './PopupVote'
import { systemName } from '../../config'

const WorkPage = props => {
  const {
    history,
    workStore,
    loadingAnimationStore,
    notificationStore,
    authenticationStore,
    documentAccessibilityStore,
    match,
  } = props
  const { currentUser } = authenticationStore
  const { selectUserData } = selectPeopleStore

  const { queryParams } = workStore
  const { isUnread } = history.location.state || {}

  const location = useLocation()
  const queryStringParsed = queryString.parse(location.search, {
    arrayFormat: 'index',
  })

  let { code_work } = match.params
  const {
    isOpen: isVisibleDrawerWork,
    handleOpen: handleOpenDrawerWork,
    handleClose: handleCloseDrawerWork,
  } = useOpenItem()
  const {
    isOpen: isVisiblePopupWorkForm,
    handleOpen: handleOpenPopupWorkForm,
    handleClose: handleClosePopupWorkForm,
  } = useOpenItem()
  const {
    isOpen: isVisiblePopupUpdateWork,
    handleOpen: handleOpenPopupUpdateWork,
    handleClose: handleClosePopupUpdateWork,
  } = useOpenItem()
  const {
    isOpen: isVisibleAddPersonWork,
    handleOpen: handleOpenAddPersonWork,
    handleClose: handleCloseAddPersonWork,
  } = useOpenItem()
  const {
    isOpen: isVisiblePopupElectronicRelease,
    handleOpen: handleOpenPopupElectronicRelease,
    handleClose: handleClosePopupElectronicRelease,
  } = useOpenItem()
  const {
    isOpen: isVisibleAddPersonVote,
    handleOpen: handleOpenAddPersonVote,
    handleClose: handleCloseAddPersonVote,
  } = useOpenItem()

  const [viewAll, setViewAll] = useState([])
  const [isViewAll, setIsViewAll] = useState(false)
  const [loading, setLoading] = useState(true)
  const userNames = viewAll?.map(item => item.assignee.user_name)

  const fetchDetails = async () => {
    if (code_work) {
      handleOpenDrawerWork()
      const parentId = utils.getParameterByName('parent_id')
      loadingAnimationStore.setShowSpinInline(true)
      try {
        if (parentId) {
          await workStore.getListSubWork(parentId)
        }
        await workStore.getWorkDetail(code_work)
      } catch (err) {
        history.push('/works')
        handleCloseDrawerWork()
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra')
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    }
  }

  const fetchDetailsV2 = async () => {
    if (code_work) {
      handleOpenDrawerWork()
      const parentId = utils.getParameterByName('parent_id')
      loadingAnimationStore.setShowSpinInline(true)
      try {
        if (parentId) {
          await workStore.getListSubWork(parentId)
        }
        await workStore.getWorkDetailV2(code_work)
      } catch (err) {
        history.push('/works')
        handleCloseDrawerWork()
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra')
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const response = await documentAccessibilityStore.getDocumentAccessibilities(
          'WORKS',
          'VIEW_ALL'
        )
        setViewAll(response.data)
        setIsViewAll(
          response.data.some(
            item => item.assignee.user_name === currentUser?.username
          )
        )
        setLoading(false)
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
        setLoading(false)
      }
    })()
  }, [currentUser?.username, documentAccessibilityStore])

  useEffect(() => {
    if (loading) return
    ;(queryStringParsed.document_code || queryStringParsed.mission_code) &&
      handleOpenPopupWorkForm()
    if (code_work) {
      workStore.setQueryParams({
        ...queryParams,
        ...queryStringParsed,
        // assignee: queryStringParsed.assignee
        //   ? queryStringParsed.assignee.join('&')
        //   : null,
        page: 0,
      })
      ;(async () => {
        try {
          // Ẩn lọc công việc theo tháng theo yêu cầu mới
          // workStore.setFilter('toDateWork', moment().format(ISO_DATE_FORMAT))
          // workStore.setFilter('fromDateWork', moment().subtract(30, 'd').format(ISO_DATE_FORMAT))
          // await workStore.getWorkList()
          if (isViewAll) {
            await fetchDetailsV2()
          } else {
            await fetchDetails()
          }
        } catch (err) {
          console.log(err)
          message.error(err?.vi || 'Đã có lỗi xảy ra!')
        } finally {
        }
      })()
    }

    return () => {
      workStore.clearWorkStore()
      notificationStore.clearNotificationType()
      if (!window.location.pathname.startsWith('/works')) {
        workStore.clearQueryParams()
        selectPeopleStore.clearSelectPeopleStore()
      }
    }
  }, [code_work, isViewAll, loading])

  const onClosesDrawerWork = () => {
    if (
      queryParams &&
      (queryParams.title ||
        (queryParams.from_date && queryParams.to_date) ||
        queryParams.status ||
        queryParams.permission ||
        queryParams.assignee)
    ) {
      const queryStringStringify = queryString.stringify(
        {
          title: queryParams.title,
          from_date: queryParams.from_date,
          to_date: queryParams.to_date,
          status: queryParams.status,
          permission: queryParams.permission,
          assignee: queryParams.assignee,
        },
        {
          skipNull: true,
        }
      )
      history.replace(`/works?${queryStringStringify}`)
    } else {
      history.replace('/works')
    }
    workStore.clearWorkDetail()
    workStore.getWorkList()
    workStore.getWorkListV2()
    handleCloseDrawerWork()
  }
  const [listHandler, setListHandler] = useState(true)
  const handleResetHandler = () => {
    setListHandler(true)
  }

  return (
    <WorkPageWrapper isVisibleDrawerWork={isVisibleDrawerWork}>
      <DashboardLayout>
        <Helmet>
          <title>Công việc | {systemName} Công việc</title>
        </Helmet>
        <PageTitle location={props.location}>
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__WORK}>
            <Button
              type={'primary'}
              icon={<PlusOutlined />}
              onClick={() => {
                handleOpenPopupWorkForm()
                handleResetHandler()
              }}>
              Tạo công việc mới
            </Button>
          </AccessControlAction>
        </PageTitle>

        <ListWork
          code_work={code_work}
          handleOpenDrawerWork={handleOpenDrawerWork}
          queryStringParsed={queryStringParsed}
          listHandler={listHandler}
          isUnread={isUnread}
        />
        {isVisibleDrawerWork && (
          <DrawerWork
            openPopupWorkForm={handleOpenPopupWorkForm}
            openPopupUpdateWork={handleOpenPopupUpdateWork}
            openPopupAddPersonWork={handleOpenAddPersonWork}
            openPopupAddPersonVote={handleOpenAddPersonVote}
            openPopupElectronicRelease={handleOpenPopupElectronicRelease}
            handleOpenDrawerWork={handleOpenDrawerWork}
            onCloseDrawerWork={onClosesDrawerWork}
            isVisibleDrawerWork={isVisibleDrawerWork}
            queryStringParsed={queryStringParsed}
            isViewAll={isViewAll}
          />
        )}
        {isVisiblePopupWorkForm && (
          <PopupWorkForm
            queryStringParsed={queryStringParsed}
            isVisiblePopupWorkForm={isVisiblePopupWorkForm}
            handleCloseWorkForm={handleClosePopupWorkForm}
            listHandler={listHandler}
            setListHandler={setListHandler}
          />
        )}
        {isVisiblePopupUpdateWork && (
          <PopupUpdateWork
            match={match}
            isViewAll={isViewAll}
            isVisiblePopupUpdateWork={isVisiblePopupUpdateWork}
            handleCloseUpdateWork={handleClosePopupUpdateWork}
          />
        )}
        <PopupAddPersonWork
          isVisibleAddPersonWork={isVisibleAddPersonWork}
          handleCloseAddPersonWork={() => {
            handleCloseAddPersonWork()
          }}
        />
        <PopupElectronicReleaseForm
          isVisiblePopupElectronicRelease={isVisiblePopupElectronicRelease}
          handleCloseElectronicRelease={handleClosePopupElectronicRelease}
        />
        <PopupAddPersonVote
          isVisibleAddPersonVote={isVisibleAddPersonVote}
          handleCloseAddPersonVote={() => {
            handleCloseAddPersonVote()
          }}
        />
      </DashboardLayout>
    </WorkPageWrapper>
  )
}

WorkPage.propTypes = {}

export default inject(
  'workStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore',
  'authenticationStore',
  'documentAccessibilityStore'
)(observer(WorkPage))
